var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarMeetings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.57,
    height: 13.571,
    viewBox: "0 0 13.57 13.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar-clock",
    d: "M13.57,3.958v.565H0V3.958A2.828,2.828,0,0,1,2.827,1.131h.565V.565A.566.566,0,0,1,3.958,0h0a.566.566,0,0,1,.565.565v.565H9.047V.565A.566.566,0,0,1,9.612,0h0a.566.566,0,0,1,.565.565v.565h.565A2.828,2.828,0,0,1,13.57,3.958Zm0,5.655A3.958,3.958,0,1,1,9.612,5.655,3.963,3.963,0,0,1,13.57,9.613Zm-2.827.331-.565-.565v-.9a.566.566,0,0,0-.565-.565h0a.566.566,0,0,0-.565.565V9.613a.564.564,0,0,0,.166.4l.731.731a.566.566,0,0,0,.8,0h0a.566.566,0,0,0,0-.8Zm-6.22-.331A5.078,5.078,0,0,1,6.417,5.655H0v5.089a2.828,2.828,0,0,0,2.827,2.827h3.59A5.078,5.078,0,0,1,4.523,9.613Z",
    fill: "#387F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMeetings);
export default __webpack_public_path__ + "static/media/sidebar-meetings.5ba1c2659b570b1a8487f8c31c9f6009.svg";
export { ForwardRef as ReactComponent };